
// Configuration settings for the application
export const config = {
  // Google Maps API key
  googleMapsApiKey: 'AIzaSyB909KrPMKGlTjCSRChbaY8FNx3BIt4ufc',
  
  // Google API Key (used for Maps and Translate)
  googleApiKey: 'AIzaSyB909KrPMKGlTjCSRChbaY8FNx3BIt4ufc',
  
  // Default map center (Calgary)
  defaultMapCenter: {
    lat: 51.0447,
    lng: -114.0719
  }
};
